/** Broker names for integration-request dropdowns (Features page + landing waitlist). */
export const BROKER_INTEGRATION_OPTIONS = [
  'Alpaca',
  'Ally Invest',
  'Charles Schwab',
  'CenterPoint Securities',
  'E*TRADE',
  'Fidelity',
  'Firstrade',
  'Interactive Brokers',
  'Lightspeed Trading',
  'Questrade',
  'Robinhood',
  'Tastyworks',
  'Tradier',
  'Webull',
  'Other',
];
